module.exports = __webpack_public_path__ + "static/img/9.77873f62.png";